import React from "react";

import msem from "../msem.svg";
import "./Login.css";

const LoginLayout = ({ children }) => (
  <div className="login">
    <div className="login--container">
      <header>
        <img src={msem} alt="ESF+" />
      </header>
      {children}
    </div>
  </div>
);

export default LoginLayout;



// WEBPACK FOOTER //
// ./src/login/Layout.js